var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.839844,
    y: 0.570312,
    width: 24.3984,
    height: 24.3984,
    rx: 12.1992,
    fill: "#00CE8D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.37954 6.21094C8.45314 6.21094 7.70215 6.96193 7.70215 7.88833V17.6477C7.70215 18.5741 8.45314 19.3251 9.37954 19.3251H16.6991C17.6255 19.3251 18.3765 18.5741 18.3765 17.6477V10.8893C18.3765 10.3996 18.1625 9.93436 17.7907 9.61569L14.2896 6.61476C13.9856 6.35417 13.5984 6.21094 13.198 6.21094H9.37954Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3734 10.7856C18.3455 10.3344 18.1363 9.9118 17.7908 9.61569L14.2897 6.61476C13.9857 6.35417 13.5985 6.21094 13.1981 6.21094H13.1919V6.97339V9.10825C13.1919 10.0346 13.9429 10.7856 14.8693 10.7856H17.6141H18.3734Z",
    fill: "#1313C6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1615 12.3197C13.025 11.4976 14.4162 11.4976 15.2797 12.3197C16.1559 13.1539 16.1559 14.5162 15.2797 15.3504L13.4142 17.1264C12.8941 17.6215 12.0598 17.6215 11.5397 17.1264C11.0069 16.6191 11.0069 15.787 11.5397 15.2797L13.4051 13.5037C13.5881 13.3295 13.8777 13.3366 14.0519 13.5196C14.2261 13.7026 14.219 13.9922 14.036 14.1664L12.1706 15.9424C12.0165 16.089 12.0165 16.3171 12.1706 16.4637C12.3373 16.6225 12.6166 16.6225 12.7833 16.4637L14.6488 14.6877C15.1462 14.2141 15.1462 13.456 14.6488 12.9824C14.1386 12.4966 13.3026 12.4966 12.7924 12.9824L10.3051 15.3504C10.1222 15.5246 9.83259 15.5175 9.65837 15.3345C9.48416 15.1515 9.49127 14.8619 9.67426 14.6877L12.1615 12.3197Z",
    fill: "#ABABAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.b89e3cf45091da9b77199d1b126f6b01.svg";
export { ForwardRef as ReactComponent };